<template>
	<SectionContainer :isExpandable="true" class="service-locations-sms-email">
		<template #left>
			<h4>SMS/Email</h4>
		</template>
		<template #right>
			<div v-if="editMode">
				<Button
					className="btn--icon-only"
					iconClassName="icon-unsaved"
					:iconBeforeLabel="true"
				/>
				<Button
					className="btn--icon-only"
					iconClassName="icon-close"
					:iconBeforeLabel="true"
					:btnClick="handleEditMode"
				/>
			</div>
			<Button
				v-if="!editMode"
				className="btn--icon-only"
				iconClassName="icon-edit"
				:iconBeforeLabel="true"
				:btnClick="handleEditMode"
			/>
		</template>
		<template #content>
			<ServiceLocationsSmsEmailCard v-if="!editMode" />
			<ServiceLocationsSmsEmailCardEdit v-model="localData" v-else />
			<Modal
				:display="true"
				:isConfirmation="true"
				v-if="closeWithOutSaving"
			>
				<template #modal-content>
					Are you sure you want to close this section without saving?
				</template>
			</Modal>
		</template>
	</SectionContainer>
</template>

<script>
import SectionContainer from '@/components/shells/section-container/section-container';
import Button from '@/components/forms/button/button';
import Modal from '@/components/shells/modal/modals';
import ServiceLocationsSmsEmailCard from './service-locations-sms-email-card.vue';
import ServiceLocationsSmsEmailCardEdit from './service-locations-sms-email-card-edit.vue';
import _ from 'lodash';

export default {
	name: 'ServiceLocationsSmsEmail',
	components: {
		SectionContainer,
		Button,
		Modal,
		ServiceLocationsSmsEmailCard,
		ServiceLocationsSmsEmailCardEdit
	},
	props: {
		data: {
			type: Object,
			default: () => {}
		}
	},
	data() {
		return {
			localData: _.cloneDeep(this.data),
			closeWithOutSaving: false,
			editMode: false
		};
	},
	methods: {
		handleEditMode() {
			this.editMode = !this.editMode;
		}
	},
	watch: {
		localData: {
			deep: true,
			handler(newValue) {
				console.log(newValue);
			}
		}
	}
};
</script>

<style lang="scss" scoped>
.service-locations-sms-email {
	&__items,
	&__items-edit-mode {
		display: flex;
		gap: $gutter-md;
	}

	h4 {
		margin-block-start: 0;
		margin-block-end: 0;
	}
}
</style>
